import React from "react";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";

const TacticaOperativa = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  useAppSettings();
  const modules = [
    {
      title: "Sucursales",
      description: "Gestion de sucursales junto con tantica de juego",
      icon: "fa-store",
      path: "/sucursales",
      color: "#50B7C0",
    },
    {
      title: "Incidencias",
      description:
        "Control de incidencias por sucursal retardo, no programados, sin entrada, sin salida, etc",
      icon: "fa-triangle-exclamation",
      path: "/sucursales/incidencias",
      color: "#dc3545",
    },
    {
      title: "Cumpleaños",
      description:
        "Calendario de festejos para mantener la cultura y motivación del equipo.",
      icon: "fa-cake-candles",
      path: "/birthdates",
      color: "#e83e8c",
    },
    {
      title: "Operación al Momento",
      description: "Análisis de cobertura y riesgo operativo .",
      icon: "fa-shield-halved",
      path: "/riesgo-operativo",
      color: "#ffc107",
    },
    {
      title: "Plantilla de Líderes",
      description: "Visualización de la estructura de liderazgo por sucursal.",
      icon: "fa-users-gear",
      path: "/tactica-operativa/lideres",
      color: "#4A90E2",
    },
    // {
    //   title: "Ausentismo",
    //   description:
    //     "Reporte y control de ausentismo por sucursal y colaborador.",
    //   icon: "fa-user-clock",
    //   path: "/tactica-operativa/ausentismo",
    //   color: "#6f42c1",
    // },
  ];

  return (
    <Layout>
      <Title
        baseTitle="Operación"
        basePath="/tactica-operativa"
        activeTitle="Táctica operativa"
        title="Táctica Operativa"
      />

      <div className="container-fluid p-4 mt-2">
        {/* <div className="row mb-4">
          <div className="col-12">
            <div
              className="card border-0 bg-azul text-white p-4 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="fw-bold mb-2">¡Hola, {user?.name}!</h2>
                  <p className="opacity-80 mb-0 fs-16px">
                    Bienvenido al centro de mando táctico. Aquí puedes gestionar
                    la operación diaria de todas las sucursales de manera
                    centralizada.
                  </p>
                </div>
                <div className="col-md-4 text-end d-none d-md-block">
                  <i
                    className="fa-solid fa-chess-knight opacity-20"
                    style={{ fontSize: "100px" }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="row g-4">
          {modules.map((module, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div
                className="card h-100 border-0 shadow-sm hover-card bg-white"
                style={{
                  cursor: "pointer",
                  transition:
                    "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  borderRadius: "20px",
                  overflow: "hidden",
                  position: "relative",
                }}
                onClick={() => navigate(module.path)}
              >
                <div className="card-body d-flex flex-column align-items-center text-center p-4 pt-5">
                  <div
                    className="icon-container mb-4 d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "white",
                      borderRadius: "22px",
                      color: module.color,
                      border: `1px solid ${module.color}30`,
                    }}
                  >
                    <i className={`fa-solid ${module.icon} fs-1`}></i>
                  </div>
                  <h4
                    className="card-title fw-bold mb-3"
                    style={{ color: "#2c3e50" }}
                  >
                    {module.title}
                  </h4>
                  <p
                    className="card-text text-muted fs-14px px-2"
                    style={{ lineHeight: "1.6" }}
                  >
                    {module.description}
                  </p>

                  <div className="mt-auto pt-4 w-100">
                    <div
                      className="module-btn py-2 w-100 rounded-3 fw-bold transition-all text-white"
                      style={{
                        backgroundColor: module.color,
                        fontSize: "14px",
                        boxShadow: `0 4px 10px ${module.color}40`,
                      }}
                    >
                      Ir{" "}
                      <i className="fa-solid fa-chevron-right ms-2 fs-12px"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
                    .hover-card:hover {
                        transform: translateY(-12px);
                        box-shadow: 0 15px 30px rgba(0,0,0,0.12) !important;
                    }
                    .hover-card:hover .icon-container {
                        transform: scale(1.1) rotate(5deg);
                        transition: all 0.3s ease;
                        background-color: #f8f9fa !important;
                    }
                    .hover-card:active {
                        transform: translateY(-5px);
                    }
                    .transition-all {
                        transition: all 0.2s ease;
                    }
                    .module-btn:hover {
                        opacity: 0.9;
                        transform: scale(1.02);
                    }
                `}
      </style>
    </Layout>
  );
};

export default TacticaOperativa;
